import Axios from '@/services/axios-instance/axios.service';
class AddressService {
  async findAddress(searchTerm, countryCode = 'GBR', limit = 10) {
    try {
      const { data } = await Axios.post('/address/find-address', {
        searchTerm: searchTerm,
        countryCode: countryCode,
        limit: limit,
        Language: 'en'
      });

      if (data.Items && data.Items.length > 0) {
        return {
          success: true,
          items: data.Items.map((item) => ({
            id: item.Id,
            text: item.Text,
            description: item.Description,
            highlight: item.Highlight,
            isContainer: item.Type === 'Container' // e.g. "Street", "Postcode"
          }))
        };
      }

      return { success: false, items: [], message: 'No addresses found' };
    } catch (err) {
      console.error('Loqate Find error:', err);
      return { success: false, items: [], message: 'Address lookup failed' };
    }
  }

  async retrieveAddress(id) {
    try {
      const { data } = await Axios.post('/address/retrieve-address', {
        id: id
      });

      if (data.Items && data.Items.length > 0) {
        const a = data.Items[0];
        return {
          success: true,
          address: {
            address1: [a.Line1, a.Line2].filter(Boolean).join(', '),
            address2: a.Line3 || '',
            city: a.City || a.PostTown || '',
            state: a.Province || a.County || '',
            postcode: a.PostalCode || a.Postcode || '',
            country: a.CountryIso2 || a.CountryIso3 || ''
          }
        };
      }

      return { success: false, message: 'Address not found' };
    } catch (err) {
      console.error('Loqate Retrieve error:', err);
      return { success: false, message: 'Failed to retrieve address' };
    }
  }

  /**
   * Auto-verify an address without modifying the original
   * @param {Object} address - Address object with fields
   * @param {string} country - Country code (GBR, IRL, etc.)
   * @param {Object} options - Additional options
   * @returns {Promise<Object>} - Verification result with status only
   */
  // async autoVerifyAddress(address, country = 'GBR', options = {}) {
  //   try {
  //     // Build the address object for the API
  //     const addressInput = {
  //       Address1: address.address1 || '',
  //       Address2: address.address2 || '',
  //       Locality: address.city || '',
  //       Province: address.state || '',
  //       PostalCode: address.postcode || '',
  //       Country: country
  //     };

  //     // Build the request payload
  //     const payload = {
  //       // Key: this.apiKey,
  //       GeoCode: options.geoCode || false,
  //       Addresses: [addressInput],
  //       Options: {
  //         ServerOptions: {
  //           OutputCasing: 'Title',
  //           OutputAddressFormat: 'NO',
  //           AddressLineSeparator: '<br>',
  //           MinimumSimilarity: 70,
  //           MinimumMatchscore: 50,
  //           MinimumVerificationLevel: 2,
  //           MatchScoreAbsoluteThreshold: 60,
  //           MatchScoreThresholdFactor: 95,
  //           ConfidenceThreshold: 90,
  //           DefaultCountry: options.defaultCountry || '',
  //           ForceCountry: options.forceCountry || '',
  //           CountryFields: 'Country',
  //           CombinedVerifyMethods: 'YES',
  //           CombinedSearchMethods: 'YES',
  //           SimpleParse: 'YES',
  //           ConformToReference: 'NO',
  //           StrictReferenceMatch: 'NO',
  //           UseSymbolicTransliteration: 'YES',
  //           OutputScript: 'Latn',
  //           OutputSortType: 'AVC',
  //           ReturnVerifiedFieldsOnly: 'No',
  //           SuppressUnmatched: 'OFF',
  //           IgnoreUnmatched: 'NO'
  //         },
  //         Version: false,
  //         Certify: false,
  //         Enhance: false,
  //         Deceased: false,
  //         Goneaways: false,
  //         Process: 'Verify'
  //       }
  //     };

  //     const { data } = await Axios.post('/address/verify-address', payload);

  //     // Check for API errors
  //     if (data.Error) {
  //       return {
  //         success: false,
  //         isValid: false,
  //         message: data.Error,
  //         errorCode: data.ErrorCode
  //       };
  //     }

  //     // Process the response - data is an array of results
  //     if (Array.isArray(data) && data.length > 0) {
  //       const result = data[0];

  //       // Check if there are matches
  //       if (result.Matches && Array.isArray(result.Matches) && result.Matches.length > 0) {
  //         const match = result.Matches[0];

  //         // Parse AVC (Address Verification Code)
  //         // Example: V44-I44-P7-100
  //         // V44 = Verification Status + Post-Processed Match Level (4 = Premise)
  //         // I44 = Parsing Status + Pre-Processed Match Level (4 = Premise)
  //         // P7 = Postcode Status (P7 = PostalCodePrimary verified, PostalCodeSecondary added or changed)
  //         // 100 = Matchscore
  //         const avc = match.AVC || '';
  //         const aqi = match.AQI || '';

  //         // Parse AVC components
  //         const avcParts = avc.split('-');

  //         const verificationStatus = avcParts[0] ? avcParts[0].charAt(0) : 'N';
  //         const postProcessedLevel = avcParts[0] ? parseInt(avcParts[0].charAt(1)) || 0 : 0;
  //         const parsingStatus = avcParts[1] ? avcParts[1].charAt(0) : 'N';
  //         const preProcessedLevel = avcParts[1] ? parseInt(avcParts[1].charAt(1)) || 0 : 0;
  //         const postcodeStatus = avcParts[2] || 'P0';
  //         const matchScore = parseInt(avcParts[3]) || 0;

  //         // ── Анализ postcode status ─────────────────────────────
  //         // P0 = пусто, P1 = контекст, P2 = лексикон, P3 = добавлен
  //         // → postcode НЕ подтверждён (пользователь ввёл неверный/чужой)
  //         // P4/P5 = подтверждён с изменениями, P6/P7/P8 = подтверждён
  //         const postcodeStatusNumber = parseInt(postcodeStatus.replace('P', '')) || 0;
  //         const postcodeIsVerified = postcodeStatusNumber >= 4;
  //         const postcodeIsMissing = postcodeStatusNumber <= 3;

  //         // ── Анализ AVC / AQI ───────────────────────────────────
  //         // A = Excellent, B = Good, C = Average, D = Poor, E = Bad, F = No match
  //         const isAmatchFound = !['E', 'F'].includes(aqi);

  //         // Уровень верификации: только ≥3 (Thoroughfare) значит "адрес реально существует"
  //         const hasStreetLevelMatch = postProcessedLevel >= 3;

  //         // Verification status V = verified, P = partial, U/R = unverified
  //         const statusIsVerified = verificationStatus === 'V';
  //         const statusIsPartial = verificationStatus === 'P';
  //         const statusIsInvalid = verificationStatus === 'U' || verificationStatus === 'R';

  //         // ── Итоговая логика ────────────────────────────────────
  //         // Verified: AQI хороший + street-level + postcode подтверждён + status V
  //         const isVerified =
  //           isAmatchFound && hasStreetLevelMatch && postcodeIsVerified && statusIsVerified && matchScore >= 60;

  //         // Partial: что-то подтверждено, но не всё
  //         const isPartial =
  //           !isVerified &&
  //           isAmatchFound &&
  //           (statusIsPartial ||
  //             (hasStreetLevelMatch && !postcodeIsVerified) ||
  //             (statusIsVerified && !hasStreetLevelMatch));

  //         // Invalid: нет совпадения / плохой AQI / postcode не подтверждён и уровень ниже улицы
  //         const isInvalid =
  //           !isVerified &&
  //           !isPartial &&
  //           (!isAmatchFound || statusIsInvalid || (postcodeIsMissing && !hasStreetLevelMatch));

  //         let verificationStatusString = 'Not verified';
  //         if (isVerified) verificationStatusString = 'Verified';
  //         else if (isPartial) verificationStatusString = 'Partial';
  //         else if (isInvalid) verificationStatusString = 'Invalid';

  //         const wasCleansed = matchScore < 100;

  //         // Формируем понятное сообщение
  //         let message = 'Address verified';
  //         if (isPartial && !postcodeIsVerified) {
  //           message = 'Address partially verified — postcode could not be confirmed. Please check the postcode.';
  //         } else if (isPartial && !hasStreetLevelMatch) {
  //           message = 'Address partially verified — could not confirm street/street number.';
  //         } else if (isInvalid && postcodeIsMissing) {
  //           message = 'Address invalid — postcode does not match the street or city.';
  //         } else if (isInvalid && !isAmatchFound) {
  //           message = 'Address could not be verified.';
  //         }

  //         return {
  //           success: true,
  //           isValid: isVerified,
  //           isPartial,
  //           isInvalid,
  //           verificationStatus: verificationStatusString,
  //           avc,
  //           aqi,
  //           postProcessedLevel,
  //           preProcessedLevel,
  //           parsingStatus,
  //           postcodeStatus,
  //           matchScore,
  //           wasCleansed,
  //           message,
  //           verificationDetails: {
  //             avc,
  //             aqi,
  //             verificationStatus,
  //             postProcessedLevel,
  //             preProcessedLevel,
  //             parsingStatus,
  //             postcodeStatus,
  //             matchScore,
  //             verifiedAddressReference: {
  //               address1: match.Address1 || '',
  //               address2: match.Address2 || '',
  //               city: match.Locality || '',
  //               postcode: match.PostalCode || '',
  //               country: match.Country || '',
  //               premise: match.Premise || '',
  //               thoroughfare: match.Thoroughfare || ''
  //             }
  //           }
  //         };
  //       }

  //       return {
  //         success: false,
  //         isValid: false,
  //         verificationStatus: 'Not verified',
  //         message: 'No matching address found'
  //       };
  //     }

  //     return {
  //       success: false,
  //       isValid: false,
  //       verificationStatus: 'Not verified',
  //       message: 'No response from address verification service'
  //     };
  //   } catch (err) {
  //     console.error('Loqate Verify error:', err);
  //     return {
  //       success: false,
  //       isValid: false,
  //       verificationStatus: 'Not verified',
  //       message: err.message || 'Address verification failed'
  //     };
  //   }
  // }
  async autoVerifyAddress(address, country = 'GBR', options = {}) {
    // ── ISO-2 → ISO-3 完整映射表 ──────────────────────────────
    const ISO2_TO_ISO3 = {
      AF: 'AFG',
      AX: 'ALA',
      AL: 'ALB',
      DZ: 'DZA',
      AS: 'ASM',
      AD: 'AND',
      AO: 'AGO',
      AI: 'AIA',
      AQ: 'ATA',
      AG: 'ATG',
      AR: 'ARG',
      AM: 'ARM',
      AW: 'ABW',
      AU: 'AUS',
      AT: 'AUT',
      AZ: 'AZE',
      BS: 'BHS',
      BH: 'BHR',
      BD: 'BGD',
      BB: 'BRB',
      BY: 'BLR',
      BE: 'BEL',
      BZ: 'BLZ',
      BJ: 'BEN',
      BM: 'BMU',
      BT: 'BTN',
      BO: 'BOL',
      BQ: 'BES',
      BA: 'BIH',
      BW: 'BWA',
      BV: 'BVT',
      BR: 'BRA',
      IO: 'IOT',
      BN: 'BRN',
      BG: 'BGR',
      BF: 'BFA',
      BI: 'BDI',
      CV: 'CPV',
      KH: 'KHM',
      CM: 'CMR',
      CA: 'CAN',
      KY: 'CYM',
      CF: 'CAF',
      TD: 'TCD',
      CL: 'CHL',
      CN: 'CHN',
      CX: 'CXR',
      CC: 'CCK',
      CO: 'COL',
      KM: 'COM',
      CG: 'COG',
      CD: 'COD',
      CK: 'COK',
      CR: 'CRI',
      CI: 'CIV',
      HR: 'HRV',
      CU: 'CUB',
      CW: 'CUW',
      CY: 'CYP',
      CZ: 'CZE',
      DK: 'DNK',
      DJ: 'DJI',
      DM: 'DMA',
      DO: 'DOM',
      EC: 'ECU',
      EG: 'EGY',
      SV: 'SLV',
      GQ: 'GNQ',
      ER: 'ERI',
      EE: 'EST',
      SZ: 'SWZ',
      ET: 'ETH',
      FK: 'FLK',
      FO: 'FRO',
      FJ: 'FJI',
      FI: 'FIN',
      FR: 'FRA',
      GF: 'GUF',
      PF: 'PYF',
      TF: 'ATF',
      GA: 'GAB',
      GM: 'GMB',
      GE: 'GEO',
      DE: 'DEU',
      GH: 'GHA',
      GI: 'GIB',
      GR: 'GRC',
      GL: 'GRL',
      GD: 'GRD',
      GP: 'GLP',
      GU: 'GUM',
      GT: 'GTM',
      GG: 'GGY',
      GN: 'GIN',
      GW: 'GNB',
      GY: 'GUY',
      HT: 'HTI',
      HM: 'HMD',
      VA: 'VAT',
      HN: 'HND',
      HK: 'HKG',
      HU: 'HUN',
      IS: 'ISL',
      IN: 'IND',
      ID: 'IDN',
      IR: 'IRN',
      IQ: 'IRQ',
      IE: 'IRL',
      IM: 'IMN',
      IL: 'ISR',
      IT: 'ITA',
      JM: 'JAM',
      JP: 'JPN',
      JE: 'JEY',
      JO: 'JOR',
      KZ: 'KAZ',
      KE: 'KEN',
      KI: 'KIR',
      KP: 'PRK',
      KR: 'KOR',
      KW: 'KWT',
      KG: 'KGZ',
      LA: 'LAO',
      LV: 'LVA',
      LB: 'LBN',
      LS: 'LSO',
      LR: 'LBR',
      LY: 'LBY',
      LI: 'LIE',
      LT: 'LTU',
      LU: 'LUX',
      MO: 'MAC',
      MG: 'MDG',
      MW: 'MWI',
      MY: 'MYS',
      MV: 'MDV',
      ML: 'MLI',
      MT: 'MLT',
      MH: 'MHL',
      MQ: 'MTQ',
      MR: 'MRT',
      MU: 'MUS',
      YT: 'MYT',
      MX: 'MEX',
      FM: 'FSM',
      MD: 'MDA',
      MC: 'MCO',
      MN: 'MNG',
      ME: 'MNE',
      MS: 'MSR',
      MA: 'MAR',
      MZ: 'MOZ',
      MM: 'MMR',
      NA: 'NAM',
      NR: 'NRU',
      NP: 'NPL',
      NL: 'NLD',
      NC: 'NCL',
      NZ: 'NZL',
      NI: 'NIC',
      NE: 'NER',
      NG: 'NGA',
      NU: 'NIU',
      NF: 'NFK',
      MP: 'MNP',
      NO: 'NOR',
      OM: 'OMN',
      PK: 'PAK',
      PW: 'PLW',
      PS: 'PSE',
      PA: 'PAN',
      PG: 'PNG',
      PY: 'PRY',
      PE: 'PER',
      PH: 'PHL',
      PN: 'PCN',
      PL: 'POL',
      PT: 'PRT',
      PR: 'PRI',
      QA: 'QAT',
      RE: 'REU',
      RO: 'ROU',
      RU: 'RUS',
      RW: 'RWA',
      BL: 'BLM',
      SH: 'SHN',
      KN: 'KNA',
      LC: 'LCA',
      MF: 'MAF',
      PM: 'SPM',
      VC: 'VCT',
      WS: 'WSM',
      SM: 'SMR',
      ST: 'STP',
      SA: 'SAU',
      SN: 'SEN',
      RS: 'SRB',
      SC: 'SYC',
      SL: 'SLE',
      SG: 'SGP',
      SX: 'SXM',
      SK: 'SVK',
      SI: 'SVN',
      SB: 'SLB',
      SO: 'SOM',
      ZA: 'ZAF',
      GS: 'SGS',
      SS: 'SSD',
      ES: 'ESP',
      LK: 'LKA',
      SD: 'SDN',
      SR: 'SUR',
      SJ: 'SJM',
      SE: 'SWE',
      CH: 'CHE',
      SY: 'SYR',
      TW: 'TWN',
      TJ: 'TJK',
      TZ: 'TZA',
      TH: 'THA',
      TL: 'TLS',
      TG: 'TGO',
      TK: 'TKL',
      TO: 'TON',
      TT: 'TTO',
      TN: 'TUN',
      TR: 'TUR',
      TM: 'TKM',
      TC: 'TCA',
      TV: 'TUV',
      UG: 'UGA',
      UA: 'UKR',
      AE: 'ARE',
      GB: 'GBR',
      US: 'USA',
      UM: 'UMI',
      UY: 'URY',
      UZ: 'UZB',
      VU: 'VUT',
      VE: 'VEN',
      VN: 'VNM',
      VG: 'VGB',
      VI: 'VIR',
      WF: 'WLF',
      EH: 'ESH',
      YE: 'YEM',
      ZM: 'ZMB',
      ZW: 'ZWE'
    };

    const toIso3 = (code) => {
      if (!code) return 'GBR';
      const upper = String(code).toUpperCase();
      if (upper.length === 3) return upper; // уже ISO-3
      return ISO2_TO_ISO3[upper] || upper;
    };

    // ── Валидация входных данных ─────────────────────────────
    const required = ['address1', 'city', 'postcode'];
    const missing = required.filter((f) => !String(address?.[f] || '').trim());
    if (missing.length) {
      return {
        success: false,
        isValid: false,
        verificationStatus: 'Not verified',
        message: `Missing required address fields: ${missing.join(', ')}`
      };
    }

    try {
      // ── Сборка payload ─────────────────────────────────────
      const iso3 = toIso3(country);

      const addressInput = {
        Address1: address.address1 || '',
        Address2: address.address2 || '',
        Locality: address.city || '',
        Province: address.state || '',
        PostalCode: address.postcode || '',
        Country: iso3
      };

      const payload = {
        GeoCode: options.geoCode || false,
        Addresses: [addressInput],
        Options: {
          ServerOptions: {
            OutputCasing: 'Title',
            OutputAddressFormat: 'NO',
            AddressLineSeparator: '<br>',
            MinimumSimilarity: 70,
            MinimumMatchscore: 50,
            MinimumVerificationLevel: 2,
            MatchScoreAbsoluteThreshold: 60,
            MatchScoreThresholdFactor: 95,
            ConfidenceThreshold: 90,
            DefaultCountry: options.defaultCountry || '',
            ForceCountry: options.forceCountry || '',
            CountryFields: 'Country',
            CombinedVerifyMethods: 'YES',
            CombinedSearchMethods: 'YES',
            SimpleParse: 'YES',
            ConformToReference: 'NO',
            StrictReferenceMatch: 'NO',
            UseSymbolicTransliteration: 'YES',
            OutputScript: 'Latn',
            OutputSortType: 'AVC',
            ReturnVerifiedFieldsOnly: 'No',
            SuppressUnmatched: 'OFF',
            IgnoreUnmatched: 'NO'
          },
          Version: false,
          Certify: false,
          Enhance: false,
          Deceased: false,
          Goneaways: false,
          Process: 'Verify'
        }
      };

      const { data } = await Axios.post('/address/verify-address', payload);

      // ── Проверка ошибок API ────────────────────────────────
      if (data.Error) {
        return {
          success: false,
          isValid: false,
          verificationStatus: 'Not verified',
          message: data.Error,
          errorCode: data.ErrorCode
        };
      }

      // ── Обработка ответа ───────────────────────────────────
      if (!Array.isArray(data) || data.length === 0) {
        return {
          success: false,
          isValid: false,
          verificationStatus: 'Not verified',
          message: 'No response from address verification service'
        };
      }

      const result = data[0];

      if (!result.Matches || !Array.isArray(result.Matches) || result.Matches.length === 0) {
        return {
          success: false,
          isValid: false,
          verificationStatus: 'Not verified',
          message: 'No matching address found'
        };
      }

      const match = result.Matches[0];

      // ── Парсинг AVC ────────────────────────────────────────
      const avc = match.AVC || '';
      const aqi = match.AQI || '';
      const avcParts = avc.split('-');

      const verificationStatus = avcParts[0] ? avcParts[0].charAt(0) : 'N';
      const postProcessedLevel = avcParts[0] ? parseInt(avcParts[0].charAt(1), 10) || 0 : 0;
      const parsingStatus = avcParts[1] ? avcParts[1].charAt(0) : 'N';
      const preProcessedLevel = avcParts[1] ? parseInt(avcParts[1].charAt(1), 10) || 0 : 0;
      const postcodeStatus = avcParts[2] || 'P0';

      const matchScoreFromApi = Number(match.MatchScore) || 0;
      const matchScoreFromAvc = parseInt(avcParts[3], 10) || 0;
      const matchScore = matchScoreFromApi || matchScoreFromAvc;

      // ── Анализ postcode status ─────────────────────────────
      const postcodeStatusNumber = parseInt(postcodeStatus.replace('P', ''), 10) || 0;
      const postcodeIsMissing = postcodeStatusNumber <= 3;

      // ── Анализ AVC / AQI ───────────────────────────────────
      // AQI "E" при AVC "V44" — адрес найден с исправлениями, а не «not found»
      const isAmatchFound = aqi !== 'F' && (aqi !== 'E' || verificationStatus === 'V');
      // Loqate не содержит Eircode: для IE ответ "A22/A33" с уровнем разбора I44 — максимум возможного
      const isIreland = iso3 === 'IRL';
      const hasStreetLevelMatch =
        (isIreland ? Math.max(postProcessedLevel, preProcessedLevel) : postProcessedLevel) >= 3;
      const statusIsVerified = verificationStatus === 'V' || (isIreland && verificationStatus === 'A');
      const statusIsPartial = verificationStatus === 'P';
      const statusIsInvalid = verificationStatus === 'U' || verificationStatus === 'R';

      // ── Проверка согласованности полей ─────────────────────
      const norm = (s) =>
        String(s || '')
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]/g, '');

      // eslint-disable-next-line no-inner-declarations
      function isSimilar(a, b, maxDistance = 2) {
        if (a === b) return true;
        if (!a || !b) return false;
        if (Math.abs(a.length - b.length) > maxDistance) return false;
        let diff = 0;
        const len = Math.min(a.length, b.length);
        for (let i = 0; i < len; i++) if (a[i] !== b[i]) diff++;
        diff += Math.abs(a.length - b.length);
        return diff <= maxDistance;
      }

      const inputCity = norm(address.city);
      const inputPostcode = norm(address.postcode);
      const inputState = norm(address.state) === 'na' ? '' : norm(address.state);
      const inputStreet = norm(address.address1);

      const matchedCity = norm(match.Locality || match.DeliveryInstallationAreaName);
      const matchedPostcode = norm(match.PostalCodePrimary || match.PostalCode);
      const matchedState = norm(match.AdministrativeArea || match.Province);
      const matchedStreet = norm(match.Thoroughfare);

      // Для стран вроде IE статус P-уровня часто низкий, хотя индекс совпадает с эталонным
      const eircodeIsValid = /^([ac-fhknprtv-y]\d{2}|d6w)[0-9ac-fhknprtv-y]{4}$/.test(inputPostcode);
      const postcodeIsVerified =
        postcodeStatusNumber >= 4 ||
        (!!inputPostcode && !!matchedPostcode && inputPostcode === matchedPostcode) ||
        (isIreland && eircodeIsValid);

      // Точно подтверждённый индекс + улица перевесят название населённого пункта (напр. Tower вместо Cork)
      const postcodeAndStreetConfirmed =
        verificationStatus === 'V' &&
        postProcessedLevel >= 3 &&
        postcodeStatusNumber >= 5 &&
        !!inputPostcode &&
        inputPostcode === matchedPostcode;
      const cityMatches =
        !inputCity || !matchedCity || isSimilar(inputCity, matchedCity, 2) || postcodeAndStreetConfirmed;
      const postcodeMatches = isIreland || !inputPostcode || !matchedPostcode || inputPostcode === matchedPostcode;
      // "Dublin" vs "Co. Dublin"
      const stateMatches =
        !inputState ||
        !matchedState ||
        inputState === matchedState ||
        matchedState.endsWith(inputState) ||
        inputState.endsWith(matchedState);
      // norm() убирает пробелы, поэтому слова берём из исходного названия улицы ("Rd" vs "Road")
      const streetWords = String(match.ThoroughfareName || match.Thoroughfare || '')
        .toLowerCase()
        .split(/[^a-z0-9]+/)
        .filter((w) => w.length > 2);
      const inputStreetFull = norm(`${address.address1} ${address.address2}`);
      const streetMatches =
        !inputStreet ||
        !matchedStreet ||
        inputStreetFull.includes(matchedStreet) ||
        streetWords.some((word) => inputStreetFull.includes(word));

      const isConsistent = cityMatches && postcodeMatches && stateMatches && streetMatches;

      // ── Итоговая логика ────────────────────────────────────
      const isVerified =
        isAmatchFound &&
        hasStreetLevelMatch &&
        postcodeIsVerified &&
        statusIsVerified &&
        matchScore >= 60 &&
        isConsistent;

      const isPartial =
        !isVerified &&
        isAmatchFound &&
        (statusIsPartial ||
          (hasStreetLevelMatch && !postcodeIsVerified) ||
          (statusIsVerified && !hasStreetLevelMatch) ||
          !isConsistent);

      const isInvalid =
        !isVerified && !isPartial && (!isAmatchFound || statusIsInvalid || (postcodeIsMissing && !hasStreetLevelMatch));

      let verificationStatusString = 'Not verified';
      if (isVerified) verificationStatusString = 'Verified';
      else if (isPartial) verificationStatusString = 'Partial';
      else if (isInvalid) verificationStatusString = 'Invalid';

      const wasCleansed = matchScore < 100;

      // ── Сообщение пользователю ─────────────────────────────
      let message = 'Address verified';
      if (isVerified && wasCleansed) {
        message = 'Address verified with corrections applied.';
      } else if (isPartial) {
        if (!postcodeIsVerified) {
          message = `Postcode "${address.postcode}" could not be confirmed for this street/city.`;
        } else if (!cityMatches) {
          message = `City "${address.city}" doesn't match the postcode. Did you mean "${match.Locality}"?`;
        } else if (!stateMatches) {
          message = `State "${address.state}" doesn't match. Did you mean "${match.AdministrativeArea}"?`;
        } else if (!streetMatches) {
          message = `Street "${address.address1}" couldn't be matched to the postcode.`;
        } else if (!hasStreetLevelMatch) {
          message = 'Could not confirm street or street number.';
        } else {
          message = 'Address partially verified. Please check the details.';
        }
      } else if (isInvalid) {
        if (!isAmatchFound) {
          message = 'Address could not be found. Please check all fields.';
        } else if (postcodeIsMissing) {
          message = 'Postcode does not match the street or city.';
        } else {
          message = 'Address is invalid.';
        }
      }

      return {
        success: true,
        isValid: isVerified,
        isPartial,
        isInvalid,
        verificationStatus: verificationStatusString,
        avc,
        aqi,
        postProcessedLevel,
        preProcessedLevel,
        parsingStatus,
        postcodeStatus,
        matchScore,
        wasCleansed,
        message,
        consistency: {
          cityMatches,
          postcodeMatches,
          stateMatches,
          streetMatches,
          isConsistent
        },
        verificationDetails: {
          avc,
          aqi,
          verificationStatus,
          postProcessedLevel,
          preProcessedLevel,
          parsingStatus,
          postcodeStatus,
          matchScore,
          verifiedAddressReference: {
            address1: match.Address1 || '',
            address2: match.Address2 || '',
            address3: match.Address3 || '',
            city: match.Locality || match.DeliveryInstallationAreaName || '',
            state: match.AdministrativeArea || match.Province || '',
            postcode: match.PostalCode || match.PostalCodePrimary || '',
            country: match.Country || match.ISO3166_3 || '',
            premise: match.Premise || '',
            thoroughfare: match.Thoroughfare || ''
          }
        }
      };
    } catch (err) {
      console.error('Loqate Verify error:', err);
      return {
        success: false,
        isValid: false,
        verificationStatus: 'Not verified',
        message: err.message || 'Address verification failed'
      };
    }
  }
  /**
   * Get AVC description for display
   * Example: V44-I44-P7-100
   * V44 = Verified to Premise level
   * I44 = Identified and Parsed to Premise level
   * P7 = PostalCodePrimary verified, PostalCodeSecondary added or changed
   * 100 = Matchscore (no changes)
   */
  getAVCDescription(avc) {
    if (!avc) return 'Not verified';

    const parts = avc.split('-');
    if (parts.length < 4) return 'Invalid AVC format';

    // Verification Status
    const statusMap = {
      V: 'Verified',
      P: 'Partially Verified',
      A: 'Ambiguous',
      R: 'Reverted',
      U: 'Unverified'
    };
    const status = statusMap[parts[0].charAt(0)] || parts[0].charAt(0);

    // Post-Processed Level
    const levelMap = {
      5: 'Delivery Point',
      4: 'Premise',
      3: 'Thoroughfare',
      2: 'Locality',
      1: 'Administrative Area',
      0: 'None'
    };
    const postLevel = levelMap[parts[0].charAt(1)] || parts[0].charAt(1);

    // Parsing Status
    const parsingMap = {
      I: 'Identified and Parsed',
      U: 'Unable to parse'
    };
    const parsing = parsingMap[parts[1].charAt(0)] || parts[1].charAt(0);

    // Pre-Processed Level
    const preLevel = levelMap[parts[1].charAt(1)] || parts[1].charAt(1);

    // Postcode Status
    const postcodeMap = {
      P8: 'PostalCodePrimary and Secondary verified',
      P7: 'Primary verified, Secondary added/changed',
      P6: 'PostalCodePrimary verified',
      P5: 'Primary verified with small change',
      P4: 'Primary verified with large change',
      P3: 'PostalCodePrimary added',
      P2: 'Primary identified by lexicon',
      P1: 'Primary identified by context',
      P0: 'PostalCodePrimary empty'
    };
    const postcode = postcodeMap[parts[2]] || parts[2];

    // Matchscore
    const matchScore = parts[3];

    return `${status} (${postLevel}) | ${parsing} (${preLevel}) | ${postcode} | Match Score: ${matchScore}%`;
  }

  /**
   * Get AQI description
   * A: Excellent, B: Good, C: Average, D: Poor, E: Bad, F: No match
   */
  getAQIDescription(aqi) {
    const descriptions = {
      A: 'Excellent quality - verified to premise level without changes',
      B: 'Good quality - verified to thoroughfare level with minor changes',
      C: 'Average quality - verified to locality level with moderate changes',
      D: 'Poor quality - only verified to locality level with significant changes',
      E: 'Bad quality - address could not be properly verified',
      F: 'No match found - address could not be validated'
    };
    return descriptions[aqi] || 'Quality unknown';
  }
}

export default new AddressService();
